<template>
  <div>
    <div v-if="noteAlertShow" class="note row mx-0 py-4">
      <div class="col-1 d-flex align-items-center justify-content-center">
        <img
          alt="info"
          class="img-fluid"
          height="30"
          src="@/assets/images/create-survey/info.svg"
          width="30"
        />
      </div>
      <div class="col-10 alert-text fst-italic text-start">
        In this section, all questions and answers are preset, you can edit
        brand name individually or apply it across all questions
      </div>
      <div class="col-1 d-flex align-items-center justify-content-center">
        <img
          alt="info"
          class="img-fluid close cursor-pointer"
          height="26"
          src="@/assets/images/shapes/close.svg"
          width="26"
          @click="noteAlertShow = !noteAlertShow"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheAlert",
  data() {
    return {
      noteAlertShow: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.note {
  background-color: $color-red-5;
  border-radius: $radius-20;

  .alert-text {
    @extend %font-18-semiBold;
    letter-spacing: 0;
    color: $color-white;
  }
}

.close {
  width: 1.625rem;
}
</style>
